import { gql, useMutation } from './urqlHooks';

// Enum values
export const ReportReason = {
  DUPLICATED: 'DUPLICATED',
  INCORRECT_AMOUNT: 'INCORRECT_AMOUNT',
  INCORRECT_DATE: 'INCORRECT_DATE',
  NOT_RECOGNIZED: 'NOT_RECOGNIZED',
  OTHER: 'OTHER',
};

export const ReportDocumentType = {
  TAX_DOCUMENT: 'TAX_DOCUMENT',
  FEE: 'FEE',
  OBLIGATION: 'OBLIGATION',
  CREDIT: 'CREDIT',
  TRANSACTION: 'TRANSACTION',
};

export const ReportReasonLabels = {
  [ReportReason.DUPLICATED]: 'Está duplicado',
  [ReportReason.INCORRECT_AMOUNT]: 'El monto es incorrecto',
  [ReportReason.INCORRECT_DATE]: 'La fecha es incorrecta',
  [ReportReason.NOT_RECOGNIZED]: 'No lo reconozco',
  [ReportReason.OTHER]: 'Otro',
};

// Mutation to create a document report
const CREATE_DOCUMENT_REPORT = gql`
  mutation CreateDocumentReport($input: CreateDocumentReportInput!) {
    createDocumentReport(input: $input) {
      id
      companyId
      documentId
      documentType
      reason
      details
      createdAt
    }
  }
`;


// Hook for creating document report
export const CreateDocumentReport = () => {
  const [result, executeMutation] = useMutation(CREATE_DOCUMENT_REPORT);
  return { ...result, executeMutation };
};

const DISMISS_POSSIBLE_DUPLICATES = gql`
  mutation DismissPossibleDuplicates($companyId: String!, $transactionId: String!) {
    dismissPossibleDuplicates(companyId: $companyId, transactionId: $transactionId)
  }
`;

export const DismissPossibleDuplicates = () => {
  const [result, executeMutation] = useMutation(DISMISS_POSSIBLE_DUPLICATES);
  return { ...result, executeMutation };
};

